export default class Category {
  constructor(data = {}) {
    return {
      id: data.id || "",
      name: data.name || "",
      deleted: data.deleted || false,
    };
  }
}
